// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"449":"e27060ef","706":"e27060ef"}[chunkId] + ".css";
};